import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import DashboardService from "../../services/dashboard.service";

function* dashboardStart(action) {

    const year = action.payload?.year;
    let params = {year};
    const response = yield DashboardService.show(params);
    if (response && response.data) {
        yield put(actions.dashboardSuccess(response.data));
    } else {
        yield put(actions.dashboardFailure({error: "no emp data"}));
    }
}

function* dashboardStartSaga() {
    yield takeEvery(actionsTypes.DASHBOARD_START, dashboardStart);
}

export function* dashboardSaga() {
    yield all([fork(dashboardStartSaga)]);
}
